module.exports = __webpack_public_path__ + "assets/862aa80633ee1171fb694f989f69291c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channels/hu/4.png
// module id = 342
// module chunks = 1